import type { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { StorageService } from '../services/storage.service';
import { LanguageService } from '../services/language.service';

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {

  const storageService = inject(StorageService);
  const languageService = inject(LanguageService);
  
  const headers: Record<string, string> = {
    'Accept-Language': languageService.currentLanguage(),
  };
  
  if (storageService.token) {
    headers['Authorization'] = `Bearer ${storageService.token}`;
  }
  
  req = req.clone({
    setHeaders: headers,
  });
  
  return next(req);
};
